import './Planets.scss';
import { Link } from 'react-router-dom';

import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import ReplayOutlinedIcon from '@mui/icons-material/ReplayOutlined';
import JoinLeftOutlinedIcon from '@mui/icons-material/JoinLeftOutlined';
import Brightness3OutlinedIcon from '@mui/icons-material/Brightness3Outlined';
import WbSunnyOutlinedIcon from '@mui/icons-material/WbSunnyOutlined';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import FilterDramaOutlinedIcon from '@mui/icons-material/FilterDramaOutlined';
import AcUnitOutlinedIcon from '@mui/icons-material/AcUnitOutlined';

const Planets = ({ onClose }) => {
  return (
    <div className="Planets-modal-overlay" onClick={onClose}>
      <div className="Planets-modal-content" onClick={e => e.stopPropagation()}>
        <div className="planets-container">
          <h2>Planets</h2>
          <div className="planets-grid">

            <Link to="/planets/planetary-positions" className="planets-item">
              <CalendarTodayOutlinedIcon className="icon" />
              <h4>Planetary Positions</h4>
            </Link>

            <Link to="/planets/planet-transit" className="planets-item">
              <FilterDramaOutlinedIcon className="icon" />
              <h4>Planet Transit</h4>
            </Link>

            <Link to="/planets/combustion" className="planets-item">
              <LocalFireDepartmentOutlinedIcon className="icon" />
              <h4>Planet Combustion</h4>
            </Link>

            <Link to="/planets/retrograde" className="planets-item">
              <ReplayOutlinedIcon className="icon" />
              <h4>Planet Retrograde</h4>
            </Link>

            <Link to="/planets/conjunction" className="planets-item">
              <JoinLeftOutlinedIcon className="icon" />
              <h4>Planet Conjunction</h4>
            </Link>

            <Link to="/planets/eclipse-dates" className="planets-item">
              <Brightness3OutlinedIcon className="icon" />
              <h4>Eclipse Dates</h4>
            </Link>

            <Link to="/planets/solar-eclipse" className="planets-item">
              <WbSunnyOutlinedIcon className="icon" />
              <h4>Solar Eclipse</h4>
            </Link>

            <Link to="/planets/lunar-eclipse" className="planets-item">
              <DarkModeOutlinedIcon className="icon" />
              <h4>Lunar Eclipse</h4>
            </Link>

            <Link to="/planets/indian-seasons" className="planets-item">
              <FilterDramaOutlinedIcon className="icon" />
              <h4>Indian Seasons</h4>
            </Link>

            <Link to="/planets/winter-solstice" className="planets-item">
              <AcUnitOutlinedIcon className="icon" />
              <h4>Winter Solstice</h4>
            </Link>

            <Link to="/planets/summer-solstice" className="planets-item">
              <WbSunnyOutlinedIcon className="icon" />
              <h4>Summer Solstice</h4>
            </Link>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Planets;
